import { useEffect, useState } from 'react';
import { useGetEmployeeITAdminsQuery } from '@Store/api/userApiSlice';

import { Option } from '@Components/types/options';
import { Flex, Typography } from 'antd';
import { MSelect } from '@Components/Base';

import styles from './fields-styles.module.css';

interface ITAdminFieldsProps {
  compId: number;
  setValues: React.Dispatch<
    React.SetStateAction<{
      itAdmin: string;
    }>
  >;
}

const ITAdminFields: React.FC<ITAdminFieldsProps> = ({ setValues, compId }) => {
  const { data } = useGetEmployeeITAdminsQuery(compId);
  const [userOptions, setUserOptions] = useState<Array<Option>>([]);

  useEffect(() => {
    if (data) {
      const transformedUsers = data.map((user) => ({
        label: `${user.empName} | ${user.empNumber}`,
        value: String(user.userId),
      }));

      setUserOptions(transformedUsers);
    }
  }, [data]);

  return (
    <div className={styles.container}>
      <Flex vertical gap={16}>
        <div>
          <Typography.Text>
            Please choose the respective IT Admin:
          </Typography.Text>
          <MSelect
            className={styles.purchaseOfficerSelect}
            options={userOptions}
            onChange={(value) => {
              setValues((prev) => {
                return { ...prev, itAdmin: value };
              });
            }}
            placeholder="Choose IT Admin"
          />
        </div>
      </Flex>
    </div>
  );
};

export default ITAdminFields;
